import { usePublicBasket } from "@app-contexts/public/features/basket/services/usePublicBasket";
import { ProductTypeSerializer } from "@app-contexts/public/features/products/data/types/products";
import { TicketItemGroupType } from "@shared/modules/basket/types/common/ticket-item-group/ticket-item-group-type";
import { useEffect, useState } from "react";
import Select from "@ui-kit/form/Select/Select.web";
import { useTranslation } from "@shared/utils/internationalization";

export interface ItemGroupProductSelectionProps {
  productData: ProductTypeSerializer;
  itemGroup: TicketItemGroupType;
}

export const ItemGroupProductSelection = ({
  productData,
  itemGroup,
}: ItemGroupProductSelectionProps) => {
  const [productChoice, setProductChoice] = useState<number | undefined>();
  const publicBasket = usePublicBasket();
  const { t } = useTranslation();

  useEffect(() => {
    // XXX: The implicit assumption for now is that there will only be one variant per item group
    // because that's the way the back end is designed.
    if (productChoice) {
      (async () => {
        try {
          await publicBasket.modifyItemGroup(
            {
              itemGroupId: itemGroup.id,
              fieldsToUpdate: {
                preset_attribute_applied: false,
                product_attribute: productChoice,
              },
            },
            { shouldPersist: true }
          );
        } catch (error) {
          setProductChoice(undefined);
        }
      })();
    }
  }, [productChoice]);

  // dont show the default variant chosen by the backend
  const basketVariant = !itemGroup.preset_attribute_applied
    ? itemGroup.product_attribute
    : undefined;
  const chosenVariantId = productChoice ?? basketVariant;
  const chosenVariant = productData.product_attributes?.find(
    (attribute) => attribute?.id === chosenVariantId
  );

  return (
    <Select
      items={productData.product_attributes ?? []}
      onSelectedItemChange={(item) => setProductChoice(item.selectedItem?.id)}
      selectedItem={chosenVariant}
      id="product-selection"
      placeholder={t("Select an option")}
      isInvalid={!chosenVariant}
    />
  );
};
